// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import LoungeEquipment from '../_raw/ui/icon_lounge_equipment.svg';
import withIconProps from '../withIconProps';

export default withIconProps(LoungeEquipment);
